import { render } from "./cuentas.vue?vue&type=template&id=eb71ae38&scoped=true"
import script from "./cuentas.vue?vue&type=script&lang=js"
export * from "./cuentas.vue?vue&type=script&lang=js"

import "./cuentas.vue?vue&type=style&index=0&id=eb71ae38&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb71ae38"]])

export default __exports__